// Libraries
import { Response } from '@angular/http'
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//Services
import { RegisterService } from '../services/RegisterService';

@Component({
    selector: 'user-set-password',
    template: require('./HolChoosePasswordComponent.html'),
    styles: [require('./HolChoosePasswordComponent.sass')],
})

export class HolChoosePasswordComponent implements OnInit {
    message: string;
    messageType: string;
    errorMessage: string;
    private redirectUrl = "hol-login";
    private newPassword: string;
    private confirmNewPassword: string;

    private formSubmitted: boolean = false;
    private recovery: string;
    private oldEmail: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private registerService: RegisterService
    ) { }
    
    ngOnInit() {
        // Get token string from URL.
        this.route.params.forEach((params: Params) => {
            this.recovery = params['recovery'];
        });
        
        // Verify if recpvery is valid or not.
        // this.verifyRecovery();
    }

    // Called when user submit form
    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        // Process set new password
        this.setNewPassword();
    }

    private setNewPassword() {
        this.registerService.setPasswordWithActivationRecovery(this.recovery, this.oldEmail, this.newPassword)
            .subscribe(
                    complete => {
                        this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
                        this.messageType = "success";
                        
                        // Delay 5s before redirect to login page
                        setTimeout( () => {
                            this.redirect();
                        }, 5000);
                    },
                    (error: Response) => {
                        if(error.json().message == 'parent-invalid'){
                            this.message = "The email address is invalid";
                        }
                        if(error.json().message == 'recovery-invalid') {        
                            this.message = "The password was already set up"
                        }
                        this.messageType = "alert";
                        this.formSubmitted = false;
                    }
            );
    }

    private redirect() {
        // Redirect to stored url
        this.router.navigate([this.redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-register/HolChoosePasswordComponent.ts